// extracted by mini-css-extract-plugin
module.exports = {"bankReportFooter":"styles_bankReportFooter__1Iijl","error":"styles_error__1IYDa"};